import React, { useState } from "react"
import { useSpring, config, animated as a } from "react-spring"

export default function Bounce({
  defaultScale = 1.1,
  disabled = false,
  indicateAction = false,
  children,
  style,
}) {
  const [active, setActive] = useState(false)
  const { scale } = useSpring({
    from: { x: 1 },
    scale: disabled ? 1 : active || indicateAction ? defaultScale : 1,
    // onRest: () => !state && toggle(!state),
    config: config.wobbly,
  })
  return (
    <a.div
      onMouseDown={() => setActive(true)}
      onMouseUp={() => setActive(false)}
      onMouseLeave={() => setActive(false)}
      style={{
        display: "flex",
        transform: scale.interpolate(x => `scale(${x})`),
        ...style,
      }}
    >
      {children}
    </a.div>
  )
}
